import ButtonLink from 'dyl-components/atoms/ButtonLink';
import React, { useEffect, useState } from 'react';
import { Header, Icon, Loader } from 'semantic-ui-react';
import "./index.scss";
import { useForm } from 'react-hook-form';
import OfficeViewMiddleHeader from '../OfficeViewMiddleHeader';
import OfficeViewCallResults from '../OfficeViewCallResults';
import OfficeViewCallRecording from '../OfficeViewCallRecording';
import OfficeViewRecentItem from '../OfficeViewRecentItem';

const OfficeViewRecents = ({ 
    recents,
    count,
    onRecentCallClick,
    recentCall,
    onCloseRecentCall,
    onEmailClick,
    setIsLogActivityModalOpen,
    logActivityForm,
    hasIntegration,
    onTaskClick,
    onHotlistClick,
    isInHotlist,
    isLogActivityModalOpen,
    onEventClick,
    isReadingRecentCalls,
    isReadingRecentCall,
    onViewMoreClick,
    onNewContactClick,
    callResultsDisabled,
    onSave,
    onMarkVoicemailAsListened,
    isUpdatingCallResults,
    onClickToDial,
    onClickToDialList,
    isPhoneSystemSupported,
    userPhoneCreds,
    callTagOptions,
    relatedToOptions,
    callTagDisabled,
    onChangeNotes,
    onChangeResults,
    relatedToDisabled
}) => {
    const [viewCallMode, setViewCallMode] = useState(false);
    const [isCallActivityModalOpen, setIsCallActivityModalOpen] = useState(false);

    const { control, reset, handleSubmit, formState: { isValid, isDirty } } = useForm({
        mode: "onChange",
        defaultValues: {
            call_result: null,
            call_notes: "",
            call_tag: null,
            related_to: null,
            sub_tag: null
        }
    })

    const formatPerson = () => {
        const person = recentCall ? recentCall.contacts?.[0] || recentCall.users?.[0] || null : null;
        return {
            name: person?.name,
            contact_id: person?.contact_id,
            account_id: person?.account_id,
            user_id: person?.user_id,
            ...(person?.contact_id ? {
                contact_details: {
                    job_title: person?.job_title,
                    email: person?.email,
                    pipeline_stage: person?.pipeline,
                    phone: [{
                        main: true,
                        phone: person?.phone
                    }]
                }
            } : {}),
            ...(person?.account_id ? {
                account_details: {
                    customer: person?.is_customer,
                    email: person?.email,
                    account_type: person?.type,
                    phone: [{
                        main: true,
                        phone: person?.phone
                    }]
                }
            } : {})
        }
    }

    useEffect(() => {
        if (recentCall) {
            const callTag = recentCall?.tags?.[0] || "";
            const [parent_value] = (callTag?.name || "").split("/");
            const parent_id = callTagOptions?.find?.(
                (item) => item?.text === parent_value
            )?.value;
            reset({
                call_notes: recentCall.note || "",
                call_result: recentCall.user_result || null,
                call_tag: parent_id,
                sub_tag: callTag?.id,
                related_to: recentCall?.related_id
            })
        } else {
            reset();
        }
    }, [recentCall])

    const isUnknown = !!recentCall?.contacts?.filter((contact) => !contact.contact_id && !contact.account_id)?.length > 0 || recentCall?.destination?.fs_destination?.substr(0,1) === '7' ;
    const unknownCnam = recentCall?.contacts?.[0]?.contact_name || recentCall?.destination?.label || ""
    const isInternalCall = recentCall?.direction === "internal";
    return (
        viewCallMode ? (
            !isReadingRecentCall ? (
                <div className='OfficeView__midContainer' style={{padding: "25px 35px 25px 30px"}}>
                    <OfficeViewMiddleHeader
                        person={formatPerson()}
                        onRemovePerson={() => {
                            reset();
                            setViewCallMode(false);
                            onCloseRecentCall();
                        }}
                        onEmailClick={onEmailClick}
                        setIsLogActivityModalOpen={setIsLogActivityModalOpen}
                        logActivityForm={logActivityForm}
                        unknown={{unknown: isUnknown, name: unknownCnam}}
                        hasIntegration={hasIntegration}
                        onTaskClick={onTaskClick}
                        onHotlistClick={onHotlistClick}
                        isInHotlist={isInHotlist}
                        isLogActivityModalOpen={isLogActivityModalOpen}
                        onEventClick={onEventClick}
                        onNewContactClick={onNewContactClick}
                        onClickToDial={onClickToDial}
                        isPhoneSystemSupported={isPhoneSystemSupported}
                        isCallActivityFormOpen={isCallActivityModalOpen}
                        setIsCallActivityFormOpen={setIsCallActivityModalOpen}
                        isInternalCall={isInternalCall}
                        userPhoneCreds={userPhoneCreds}
                        currentCall={{company_destination: recentCall?.destination?.fs_destination}}
                    />
                    <div style={{marginTop: 30}}>
                        <OfficeViewCallRecording 
                            currentCallPhoneNumber={recentCall?.contacts?.[0]?.phone || recentCall?.users?.[0]?.extension || recentCall?.destination?.fs_destination}
                            duration={recentCall?.length}
                            callRecording={{...recentCall?.call_recording, sound_id: recentCall?.call_uuid}}
                            voicemail={recentCall?.system_result === "Missed"}
                            onMarkVoicemailAsListened={() => onMarkVoicemailAsListened?.(recentCall?.call_uuid)}
                            isInternalCall={isInternalCall}
                            isPrimaryPhone={recentCall?.contacts?.[0]?.primary}
                        />
                    </div>
                    <div>
                        {!isInternalCall && 
                            <OfficeViewCallResults
                                control={control} 
                                callResultsDisabled={callResultsDisabled}
                                recentCall={recentCall}
                                onSave={handleSubmit((data) => onSave(data, reset))}
                                onSaveDisabled={!isDirty || !isValid}
                                isSaveLoading={isUpdatingCallResults}
                                callTagOptions={callTagOptions}
                                relatedToOptions={relatedToOptions}
                                callTagDisabled={callTagDisabled}
                                onChangeNotes={onChangeNotes}
                                onChangeResults={onChangeResults}
                                relatedToDisabled={relatedToDisabled}
                            />
                        }
                    </div>
                </div>
            ) : (
                <div style={{ height: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                    <Loader active inline />
                </div>
            )
        ) : (
            !isReadingRecentCalls ? (
                <div style={{display: 'flex', height: '100%', padding: "35px 20px 35px 20px", flexDirection: 'column'}}>
                    {count === 0 && (
                        <div style={{display: 'flex', justifyContent: 'center', flex: 1, alignItems: 'center'}}>
                            <Header as={"h2"}>No Recent Calls</Header>
                        </div>
                    )}
                    {count > 0 && (
                        <div style={{flex: 1, display: 'flex', overflowY: "auto", flexDirection: 'column', gap: 20}}>
                            {recents.map((recent) => {
                                return (
                                    <OfficeViewRecentItem
                                        recent={recent}
                                        onRecentCallClick={onRecentCallClick}
                                        setViewCallMode={setViewCallMode}
                                        onMarkVoicemailAsListened={
                                            onMarkVoicemailAsListened
                                        }
                                        onClickToDialList={onClickToDialList}
                                        isPhoneSystemSupported={isPhoneSystemSupported}
                                        logActivityForm={logActivityForm}
                                    />
                                );
                            })}
                        </div>
                    )}
                    <div style={{paddingTop: 15, paddingLeft: 25}}>
                        <ButtonLink onClick={onViewMoreClick}>
                            <span>View More</span>
                            <Icon className='fa-solid fa-chevron-right' />
                        </ButtonLink>
                    </div>
                </div>
            ) : (
                <div style={{ height: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                    <Loader active inline />
                </div>
            )
            
        )
    )
}

export default OfficeViewRecents;
